// extracted by mini-css-extract-plugin
export var dateLabel = "_49-0";
export var dateLabelError = "_49-1";
export var fullWidth = "_49-2";
export var smaller = "_49-3";